import { render, staticRenderFns } from "./ReviewRecords.vue?vue&type=template&id=d253bebe&scoped=true&"
import script from "./ReviewRecords.vue?vue&type=script&lang=js&"
export * from "./ReviewRecords.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRecords.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReviewRecords.vue?vue&type=style&index=1&id=d253bebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d253bebe",
  null
  
)

export default component.exports